/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}.center[_ngcontent-%COMP%]{text-align:center}.margintop[_ngcontent-%COMP%]{margin-top:15px}mat-form-field[_ngcontent-%COMP%]{width:100%}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/admin-settings/admin-settings.component.css.shim.ngstyle.js.pre-build-optimizer.js